<template>
<div>
  <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo Documento</v-btn>
      </template>
    <v-layout row>
        <v-flex xs12>
            <v-card>
                <progress-bar :show="form.busy"></progress-bar>
                <form @submit.prevent="createDocument" @keydown="form.onKeydown($event)">
                    <v-card-title primary-title>
                        <h3 v-if="!editingDocument" class="headline mb-0">{{ $t('enrollments.document.create-title') }}</h3>
                        <h3 v-else class="headline mb-0">{{ $t('enrollments.document.update-title') }}</h3>
                    </v-card-title>

                    <v-card-text>

                        <select-input
                            :form="form"
                            :items="this.enrollments"
                            :label="$t('enrollments.document.enrollment')"
                            :v-errors="errors"
                            :value.sync="form.enrollment_id"
                            name="enrollment_id"
                            v-validate="'required'"
                        ></select-input>

                        <select-input
                            :form="form"
                            :label="$t('enrollments.document.name')"
                            :v-errors="errors"
                            :value.sync="form.document_id"
                            name="document_id"
                            v-validate="'required'"
                            :items="document_names"
                        ></select-input>

                        <text-input
                            :form="form"
                            :label="$t('enrollments.document.extension')"
                            :v-errors="errors"
                            :value.sync="form.ext"
                            name="ext"
                        ></text-input>

                        <select-input
                            :form="form"
                            :label="$t('enrollments.document.type')"
                            :v-errors="errors"
                            :value.sync="form.document_type"
                            name="document_type"
                            v-validate="'required'"
                            :items="document_types"
                        ></select-input>

                        <!-- <select-input
                            v-if="form.document_type === 'digital_sign'"
                            :form="form"
                            :label="$t('enrollments.document.signs_number')"
                            :v-errors="errors"
                            :value.sync="form.signs_number"
                            name="signs_number"
                            :items="[{value: 1, text: '1'}, {value: 2, text: '2'}]"
                            v-validate="'required'"
                        ></select-input> -->

                        <text-input
                            v-if="form.document_type === 'digital_sign'"
                            :form="form"
                            :label="$t('enrollments.document.digital_id_documet')"
                            :v-errors="errors"
                            :value.sync="form.digital_id_documet"
                            name="digital_id_documet"
                        ></text-input>

                        <div v-if="form.document_type === 'template' || form.document_type === 'read_only'" class="upload">
                          <ul>
                            <li v-for="(file) in files" :key="file.id">
                              <span>{{file.name}}</span> -
                              <span>{{file.size}}</span>
                              &nbsp;&nbsp;&nbsp;
                              <span>
                                <v-tooltip top>
                                  <v-icon
                                    small
                                    class="mr-2"
                                    @click.prevent="$refs.upload.remove(file)"
                                    slot="activator"
                                  >
                                    delete
                                  </v-icon>
                                  <span>{{$t('extracurriculares.clothes.delete')}}</span>
                                </v-tooltip>
                              </span>
                            </li>
                          </ul>
                          <div class="example-btn">
                            <file-upload
                              class="mb-2 v-btn theme--dark primary"
                              extensions="pdf"
                              accept="application/pdf"
                              :multiple="false"
                              :size="1024 * 1024 * 10"
                              v-model="files"
                              @input-filter="inputFilter"
                              @input-file="inputFile"
                              ref="upload">
                              <i class="fa fa-plus"></i>
                              {{$t('enrollments.document.select_template')}}
                            </file-upload>
                            <span v-if="filesError" class="red--text">Debe cargar archivo plantilla</span>
                          </div>
                        </div>
                        <text-area-input
                            :form="form"
                            :label="$t('enrollments.document.description')"
                            :v-errors="errors"
                            :value.sync="form.description"
                            name="description"
                            v-validate="'required'"
                        ></text-area-input>


                        <select-multiple-input
                          v-validate="'required'"
                          :form="form"
                          :items="grades"
                          :label="$t('enrollments.document.fourStep')"
                          :v-errors="errors"
                          :value.sync="form.required_next_step"
                          name="required_next_step"
                        ></select-multiple-input>

                        <v-autocomplete
                          v-model="form.students_selected"
                          :items="students"
                          box
                          chips
                          color="primary"
                          label="Seleccionar estudiantes"
                          item-text="full_name"
                          item-value="id"
                          multiple
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              :selected="data.selected"
                              close
                              class="chip--select-multi"
                              @input="removeStudent(data.item)"
                            >
                              {{ data.item.full_name }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-tile-content v-text="data.item"></v-list-tile-content>
                            </template>
                            <template v-else>
                              <v-list-tile-content>
                                <v-list-tile-title v-html="data.item.full_name"></v-list-tile-title>
                                <v-list-tile-sub-title v-html="'Familia: ' +data.item.family_id"></v-list-tile-sub-title>
                                <v-list-tile-sub-title v-html="'Grado: ' + data.item.grade"></v-list-tile-sub-title>
                              </v-list-tile-content>
                            </template>
                          </template>
                        </v-autocomplete>

                    </v-card-text>

                    <v-card-actions>
                        <submit-button v-if="!editingDocument" :form="form" :label="$t('enrollments.document.save-button')"></submit-button>
                        <submit-button v-else :form="form" :label="$t('enrollments.document.update-button')"></submit-button>
                        <v-btn @click="cancelFormSubmit" >{{ $t('enrollments.costs.cancel') }}</v-btn>
                    </v-card-actions>
                </form>
            </v-card>
        </v-flex>
    </v-layout>
  </v-dialog>
    <v-layout row>
      <v-flex xs12 >
        <v-data-table
          :headers="headers"
          :items="documents"
          class="elevation-1 mt-3"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.enrollment && props.item.enrollment.description }}</td>
            <td class="text-xs-center">{{ props.item.document && props.item.document.name }}</td>
            <td class="text-xs-center">{{ $t(`enrollments.document.types.${props.item.document_type}`) }}</td>
            <td class="text-xs-center">{{ props.item.digital_id_documet }}</td>
            <td class="text-xs-center">{{ props.item.description }}</td>
            <td class="text-xs-center">{{ props.item.ext }}</td>
            <td class="text-xs-center">{{ props.item.required_next_step === '["ALL"]' ? 'Si' : props.item.required_next_step === null ? 'No' : 'Parcial' }}</td>
            <td>
              <v-tooltip v-if="props.item.document_type === 'template' || props.item.document_type === 'read_only'" top>
                  <v-icon
                    medium
                    class="mr-2"
                    @click="showTemplate(props.item.path)"
                    slot="activator"
                  >
                    file_copy
                  </v-icon>
                <span>Ver documentos</span>
              </v-tooltip>
              <v-tooltip top>
                <v-icon
                  medium
                  class="mr-2"
                  @click="editDocument(props.item.id)"
                  slot="activator"
                >
                  edit
                </v-icon>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip top>
                <v-icon
                  medium
                  class="mr-2"
                  @click="deleteDocument(props.item.id)"
                  slot="activator"
                >
                  delete
                </v-icon>
                <span>Eliminar</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog v-model="fileDialog" max-width="600px">
      <template>
        <v-layout>
          <v-flex xs12>
            <object :data="path_file" width="600px" height="500px"></object>
          </v-flex>
        </v-layout>
      </template>
    </v-dialog>
</div>
</template>

<script>
    import Form from 'vform';
    import axios from 'axios';
    import FileUpload from 'vue-upload-component'
    export default {
        name: 'enrollment-document-create-view',
        components: {
          FileUpload,
        },
        data () {
          return {
            form: new Form({
                document_id: '',
                ext: '',
                document_type: '',
                description: '',
                required_next_step: null,
                enrollment_id: '',
                signs_number: '',
                digital_id_documet: '',
                students_selected: [],
            }),
            students: [],
            enrollments: [],
            grades: [{value: 'ALL', text: 'Todos'}],
            document_names: [],
            document_types: [
                { value: 'digital_sign', text: this.$t('enrollments.document.types.digital_sign') },
                { value: 'upload', text: this.$t('enrollments.document.types.upload') },
                { value: 'template', text: this.$t('enrollments.document.types.template') },
                { value: 'read_only', text: this.$t('enrollments.document.types.read_only') },
              ],
            headers: [
              { text: this.$t('enrollments.document.enrollment'), align: 'center', value: 'finish_date' },
              { text: this.$t('enrollments.document.name'), align: 'center', value: 'start_date' },
              { text: this.$t('enrollments.document.type'), align: 'center', value: 'start_date' },
              { text: this.$t('enrollments.document.digital_id_documet'), align: 'center', value: 'digital_id_documet' },
              { text: this.$t('enrollments.document.description'), align: 'center', value: 'family' },
              { text: this.$t('enrollments.document.extension'), align: 'center', value: 'reason' },
              { text: this.$t('enrollments.document.fourStep'), align: 'center', value: 'enrollment', sortable: false },
              { text: 'Acciones', align: 'center', value: 'acciones' }
            ],
            documents: [],
            files: [],
            editingDocument: false,
            filesError: false,
            fileDialog: false,
            path_file: '',
            dialog: false
          }
        },
        created() {
            this.initialize()
        },
        methods: {
            async initialize() {

                axios.get('/api/students')
                  .then(resp => {
                    if (resp.status === 200) {
                      this.students = resp.data.students.map(student => {
                        return {
                          full_name: `${student.full_name} - ${student.family_id} - ${student.student_number}`,
                          family_id: student.family_id,
                          grade: student.grade_level,
                          id: student.id,
                          student_number: student.student_number
                        }
                      })
                    }
                  })
                  .catch(error => console.log(error))

                const enrollments = await axios.get('/api/enrollments')
                enrollments.data.forEach(enrollment => {
                    this.enrollments.push({
                        value: enrollment.id,
                        text: enrollment.description
                    })
                });

                const documentList = await axios.get('/api/enrollments/documents');
                documentList.data.forEach(document => {
                    this.document_names.push({
                        value: document.id,
                        text: document.name
                    })
                });

                const documents = await axios.get('/api/enrollments/all_documents');
                this.documents = documents.data.documents;

                const grades = await axios.get('/api/school_grades')
                grades.data
                  .map(grade => this.grades.push({ value: grade.name, text: grade.name }));
            },

            async createDocument() {
                if (await this.formHasErrors()) return
                if(this.editingDocument) {
                  this.updateDocument()
                  return
                }
                this.filesError = false;
                if((this.form.document_type === 'template' || this.form.document_type === 'read_only') && this.files.length === 0) {
                  this.filesError = true;
                  return;
                }

                this.form.required_next_step = this.form.required_next_step !== null ? JSON.stringify(this.form.required_next_step) : null

                const { data } = await this.form.post('/api/enrollment/document/create')

                if (data.error) {
                    this.$store.dispatch('responseMessage', {
                        type: 'warning',
                        text: this.$t('enrollments.document.stored-error-text'),
                        title: this.$t('enrollments.document.stored-error-title'),
                        modal: true
                    })
                } else {
                    this.$store.dispatch('responseMessage', {
                        type: 'success',
                        text: this.$t('enrollments.document.stored-ok-text'),
                        title: this.$t('enrollments.document.stored-ok-title'),
                        modal: true
                    })
                    if (this.form.document_type === 'template' || this.form.document_type === 'read_only') {
                      this.uploadFile(data.id)
                    }
                    this.dialog = false
                    this.initialize();
                    this.form.clear();
                    this.form.reset();
                }
            },
            async updateDocument() {

              this.form.required_next_step = this.form.required_next_step !== null ? JSON.stringify(this.form.required_next_step) : null

              const { data } = await this.form.put('/api/enrollment/document/update')

                if (data.error) {
                    this.$store.dispatch('responseMessage', {
                        type: 'warning',
                        text: this.$t('enrollments.document.stored-error-text'),
                        title: this.$t('enrollments.document.stored-error-title'),
                        modal: true
                    })
                } else {
                    this.$store.dispatch('responseMessage', {
                        type: 'success',
                        text: this.$t('enrollments.document.stored-ok-text'),
                        title: this.$t('enrollments.document.stored-ok-title'),
                        modal: true
                    })
                    if ((this.form.document_type === 'template' || this.form.document_type === 'read_only') && this.files.length > 0) {
                      this.uploadFile(this.form.id)
                    }
                    this.dialog = false
                    this.editingDocument = false
                    this.initialize();
                    this.form.clear();
                    this.form.reset();
                }
            },
            editDocument(id) {
              this.dialog = true
              const documentToEdit = this.documents.filter(document => document.id === id)[0]
              this.editingDocument = true
              this.form = new Form({
                document_id: documentToEdit.document_id,
                ext: documentToEdit.ext,
                document_type: documentToEdit.document_type,
                description: documentToEdit.description,
                required_next_step: JSON.parse(documentToEdit.required_next_step === null ? "[]" : documentToEdit.required_next_step),
                enrollment_id: documentToEdit.enrollment_id,
                signs_number: documentToEdit.signs_number,
                digital_id_documet: documentToEdit.digital_id_documet,
                students_selected: documentToEdit.students.map(student => student.student_id),
                id
              })

            },
            deleteDocument(id) {
              axios.delete(`/api/enrollment/document/${id}`)
                .then(resp => {
                  if (resp.status === 200) {
                    this.documents = this.documents.filter(document => document.id !== id)
                    this.$store.dispatch('responseMessage', {
                      type: 'success',
                      text: this.$t('enrollments.create-form.document-cost-modal.document-deleted'),
                      modal: false
                    })
                  }
                })
                .catch(error => console.log(error))
            },
            inputFilter(newFile, oldFile, prevent) {
              if (newFile && !oldFile) {
                if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                  return prevent()
                }

                if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                  return prevent()
                }
              }
            },
            inputFile(newFile, oldFile) {
              if (newFile && !oldFile) {
                // add
                console.log('add', newFile)
              }
              if (newFile && oldFile) {
                // update
                console.log('update', newFile)
              }
              if (!newFile && oldFile) {
                // remove
                console.log('remove', oldFile)
              }
            },
            uploadFile(id) {
              let formData = new FormData();
              let fileData;
              this.files.forEach((file, index) => {
                fileData = this.$refs.upload.get(file.id);
                formData.append(`file_${index}`, fileData.file);
              });
              formData.append('document_id', id);
              axios.post(`/api/enrollment/document/template_file`, formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              )
              .then(resp => {
                if (resp.status === 200) {
                  this.$store.dispatch('responseMessage', {
                    type: 'success',
                    text: this.$t('extracurriculares.clothes.messages.files_saved'),
                    modal: false
                  })
                  this.$refs.upload.clear();
                  this.getClothes()
                }
              })
              .catch(error => console.log(error));
          },
          showTemplate(path) {
            this.path_file = path;
            this.fileDialog = true;
          },
          cancelFormSubmit() {
            this.editingDocument = false
            this.dialog = false
            this.form = new Form({
                document_id: '',
                ext: '',
                document_type: '',
                description: '',
                required_next_step: null,
                enrollment_id: '',
                digital_id_documet: '',
                students_selected: [],
            })
          },
          removeStudent (item) {
            const index = this.form.students_selected.indexOf(item.id)
            if (index >= 0) this.form.students_selected.splice(index, 1)
          }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/documents.vue